import React from "react";
import { GradeCardContainer, CustomAnchor } from "../utils/StyledComponents";
import { makeStyles, Typography } from "@material-ui/core";
import { GiRibbonMedal } from "react-icons/gi";
import { FormattedMessage, useIntl } from "react-intl";


const GradeCard = ({ details, opacity, onClick, accordionId, icon }) => {

  

  const intl = useIntl();
  const classes = useStyle();
  return (
    <div className="text-center">
      <p>
        <a
          class={`btn ${classes.toggleBtn}`}
          data-bs-toggle="collapse"
          href={`#${accordionId}`}
          role="button"
          aria-expanded="false"
          aria-controls={`${accordionId}`}
        >
          <div>{details.grade}</div>
          <div>
            Üstünlüklər
            {icon}
          </div>
        </a>
      </p>
      <div class="row">
        <div class="col">
          <div class="collapse multi-collapse" id={`${accordionId}`}>
            <div class="card card-body">
              <ul className={classes.ul}>
                {details?.desc.map((d) => (
                  <li>{d}</li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const useStyle = makeStyles({
  ul: {
    listStyleType: "none",
    padding: 0,
    margin: 0,
  },
  toggleBtn: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-around",
    border: "1px solid #1765B6",
    padding: "10px 0",
  },
});

export default GradeCard;
